import "./TehnicLock.css"
import strings from "../../../locales/ro.json"
import config from "../../../config";
import { useApi } from "../../../hooks/useApi";

const TehnicLock = ({canManage, active}) => {
	const { api } = useApi();
	
	function closePopup(){
		api(`handrules/${config.handrulesLobbyId}/pop`, "GET");
	}

	return active ? (
		<div className="tehnicLockContainer">
			<div className="popupBox">
				<div className="warningSign">
					<img src="./icons/warning.svg" alt="tehnic warning"/>
				</div>
				<div className="tlTitle">{strings.handrules.tehnicLock.title}</div>
				<div className="tlInfo">{strings.handrules.tehnicLock.info}</div> 
				{canManage && (
					<div className="tlButton" onClick={closePopup}>{strings.handrules.tehnicLock.resolved}</div>
				)}
			</div>
		</div>
	) : undefined;
}

export default TehnicLock;